import {h, Fragment} from "preact"
import { useFacets, useFacet } from "@nosto/preact";

const FACET_ORDER = {
    'Size': 0,
    'Body Material': 1,
    'Body Color': 2,
    'Rim Color': 3,
    'BU Size': 4,
    'Liner Type': 5,
    'Availability': 6,
    'Price': 7
};

function sortFacets(facets) {
    return [...facets].sort((a, b) => {
        const orderA = FACET_ORDER[a.name] ?? Infinity;
        const orderB = FACET_ORDER[b.name] ?? Infinity;
        return orderA - orderB;
    });
}

export function RegularFacet({ facet, index, isFirst, facetControl }) {
    const { selectedFiltersCount, toggleProductFilter } = facetControl;

    return (
        <details
            id={`Details-${facet.field}-template--23075624190267__product-grid`}
            class="facets__disclosure-vertical js-filter"
            data-index={index}
            open={isFirst}
        >
            <summary
                class="desktop facets__summary caption-large focus-offset"
                aria-label={`${facet.name} (${selectedFiltersCount} selected)`}
            >
                <div class="filters-summary">
                    <span class="facets__summary-label P-14">{facet.name}</span>
                    <svg 
                        aria-hidden="true" 
                        focusable="false" 
                        class="icon icon-caret" 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="16" 
                        height="17" 
                        viewBox="0 0 16 17" 
                        fill="none"
                    >
                        <path d="M12.2402 7.25L7.99753 11.4926L3.75489 7.25" stroke="#333333" />
                    </svg>
                </div>
            </summary>
            <div 
                id={`Facet-${index}-template--23075624190267__product-grid`}
                class="parent-display facets__display-vertical"
            >
                <fieldset class="facets-wrap parent-wrap facets-wrap-vertical mobile-facets-fieldset">
                    <legend class="visually-hidden">{facet.name}</legend>
                    <ul class="facets-layout facets-layout-list facets-layout-list--text facets__list--vertical list-unstyled mobile-facets-ul" role="list">
                        {facet.data.map((item, optIndex) => {
                            let displayValue;
                            if (facet.field === 'extra.custom-variant_body_material' && item.value === 'Vinyl') {
                                displayValue = 'Steeletex';
                            } else if (item.value === 'InStock') {
                                displayValue = 'In Stock';
                            } else {
                                displayValue = item.value;
                            }

                            return (
                                <li class="list-menu__item facets__item mobile-facets-li">
                                    <label 
                                        for={`Filter-${facet.field}-${optIndex + 1}`} 
                                        class={`facets__label facet-checkbox${item.count === 0 ? ' disabled' : ''}${item.selected ? ' active' : ''}`}
                                        aria-disabled={item.count === 0}
                                    >
                                        <input 
                                            type="checkbox"
                                            name={facet.field}
                                            value={item.value}
                                            id={`Filter-${facet.field}-${optIndex + 1}`}
                                            disabled={item.count === 0}
                                            checked={item.selected}
                                            onChange={(e) => {
                                                e.preventDefault();
                                                toggleProductFilter(facet.field, item.value, !item.selected);
                                            }}
                                        />
                                        <span class="input-text-value" aria-hidden="true">
                                            <div class="value-wrapper">
                                                {facet.field.includes('color') && <div class={`value-color-dot ${item.value.toLowerCase()}`} />}
                                                <span class="Button-C">{displayValue} </span>
                                            </div>
                                        </span>
                                        <span class="visually-hidden">{displayValue} ({item.count} products)
                                        </span>
                                    </label>
                                </li>
                            )
                        })}
                    </ul>
                </fieldset>
            </div>
        </details>
    );
}

export function PriceFacet({ index }) {
    const ranges = [
        { min: "10", max: "50" },
        { min: "50", max: "100" },
        { min: "100", max: "200" },
        { min: "200", max: "300" },
        { min: "300", max: "500" },
        { min: "500+", max: "" }
    ];

    return (
        <details 
            id="Details-filter.v.price-template--23075624190267__product-grid" 
            class="facets__disclosure-vertical js-filter" 
            data-index={index}
        >
            <summary 
                class="facets__summary caption-large focus-offset"
                aria-controls={`Facet-${index}-template--23075624190267__product-grid`}
            >
                <div class="filters-summary price">
                    <span class="Button-C">Price</span>
                    <svg 
                        aria-hidden="true" 
                        focusable="false" 
                        class="icon icon-caret" 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="16" 
                        height="17" 
                        viewBox="0 0 16 17" 
                        fill="none"
                    >
                        <path d="M12.2402 7.25L7.99753 11.4926L3.75489 7.25" stroke="#333333" />
                    </svg>
                </div>
            </summary>
            <div 
                id={`Facet-${index}-template--23075624190267__product-grid`}
                class="facets__display-vertical"
            >
                <div class="facets__header-vertical">
                </div>
                <div class="facets__price">
                    <div class="ranges">
                        {ranges.map((range, idx) => (
                            <div class="mt12" key={idx}>
                                <label class="sc-checkbox">
                                    <input 
                                        name={`range[${idx}]`} 
                                        type="checkbox" 
                                        data-min={range.min} 
                                        data-max={range.max}
                                    />
                                    <span class="sc-icon"></span>
                                    <span class="sc-label">
                                        <p class="Button-C">
                                            ${range.min}{range.max ? ` to $${range.max}` : ''}
                                        </p>
                                    </span>
                                </label>
                            </div>
                        ))}
                    </div>
                    <div class="field hidden">
                        <input 
                            class="field__input" 
                            name="filter.v.price.gte" 
                            id="Filter-Price-GTE" 
                            type="text" 
                            inputmode="decimal" 
                            placeholder="0" 
                            data-pattern="\d| |,|\." 
                            data-min="0" 
                            data-max="312.95"
                        />
                        <label class="field__label" for="Filter-Price-GTE">From</label>
                    </div>
                    <div class="field hidden">
                        <input 
                            class="field__input" 
                            name="filter.v.price.lte" 
                            id="Filter-Price-LTE" 
                            type="text" 
                            inputmode="decimal" 
                            placeholder="312.95" 
                            data-pattern="\d| |,|\." 
                            data-min="0" 
                            data-max="312.95"
                        />
                        <label class="field__label" for="Filter-Price-LTE">To</label>
                    </div>
                </div>
            </div>
        </details>
    );
}

export default function SideBar({ toggleId }) {
    const { loading, facets } = useFacets();
    
    if (!facets?.length) return null;

    const sortedFacets = sortFacets(facets);
    const totalSelectedCount = sortedFacets.reduce((count, facet) => 
        count + (facet.data?.filter(item => item.selected).length || 0)
    , 0);

    const facetControls = sortedFacets.map(facet => useFacet(facet.id));

    const handleClearAll = (e) => {
        e.preventDefault();
        sortedFacets.forEach((facet, index) => {
            const { toggleProductFilter } = facetControls[index];
            facet.data.forEach(item => {
                if (item.selected) {
                    toggleProductFilter(facet.field, item.value, false);
                }
            });
        });
    };

    return (
        <div class="facets-wrapper">
            <div class="facets-container scroll-trigger animate--fade-in">
                <input type="checkbox" id={toggleId} class="hidden" />
                <div class="facets small-hide">
                    <form id="FacetFiltersForm" class="facets__form-vertical ns-mr-4">
                        <div id="FacetsWrapperDesktop">
                            <div class="active-facets active-facets-desktop">
                                <div class="active-facets-vertical-filter">
                                    <div class="filters-title">
                                        <h2 class="Eyebrow-A" id="verticalTitle" tabindex="-1">
                                            Filter
                                        </h2>
                                        <p class="P-14">({totalSelectedCount})</p>
                                    </div>
                                    <div class="filters-clear">
                                        <button
                                            type="button"
                                            class="Button-B"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleClearAll(e);
                                            }}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                </div>
                                <div class="filters-results" />
                            </div>
                            {sortedFacets.map((facet, index) => (
                                <RegularFacet 
                                    key={facet.id} 
                                    facet={facet} 
                                    index={index + 1}
                                    isFirst={index === 0}
                                    facetControl={facetControls[index]}
                                />
                            ))}
                            <PriceFacet index={sortedFacets.length + 1} />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
